import permissions from '@constants/enums/auth/permission';

import i18n from '@plugins/i18n';

export default [
    {
        path: '/shortlists',
        component: () => import('@/views/Index.vue'),
        children: [
            {
                path: '/shortlists',
                name: 'Shortlists',
                component: () => import('@/views/Shortlists.vue'),
                meta: {
                    overline: i18n.t('investments'),
                    title: i18n.t('_page.shortlists.heading'),
                    heading: i18n.t('_page.shortlists.heading'),
                    description: i18n.t('_page.shortlists.description'),
                    organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER']
                }
            },
            {
                path: '/shortlist',
                name: 'Shortlist',
                component: () => import('@/views/Shortlist.vue'),
                meta: {
                    overline: i18n.t('investments'),
                    title: i18n.t('shortlist'),
                    heading: i18n.t('shortlist'),
                    permissions: [permissions.INVESTMENT_BOOK],
                    organisations: ['ADVISER', 'INVESTOR']
                }
            }
        ]
    }
];
